import ArtboardInspector from 'modules/shares/Inspector/ArtboardInspector'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  display: flex;
  overflow: hidden;
`

export const LoadingOverlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
/**
 * The ArtboardInspector needs to be styled with height: 100% otherwise the
 * "bottom" property that we use to position the red dashed selection lines of
 * the inspector overlays (inside "[...]/Inspector/Selection/Selection.tsx") do not work correctly.
 */
export const StyledArtboardInspector = styled(ArtboardInspector)`
  height: 100%;
`
